import React, { useState, useEffect, useRef } from 'react';
import { MDBDataTable } from 'mdbreact';
import Swal from 'sweetalert2';
import { Button, Container, IconButton } from '@mui/material';
import { baseURL } from '../base_url';
import axios from 'axios';
import { read, utils, writeFile } from 'xlsx';
import { FaUpload } from "react-icons/fa";
import { PuffLoader } from 'react-spinners';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FaDownload } from 'react-icons/fa';
import moment from 'moment';
import { RiFileExcel2Fill } from "react-icons/ri";

const AgentSaleActivity = () => {

  const daysBetweenDates = () => {
    const today = new Date();
    const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const diffTime = Math.abs(today - firstOfMonth);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }
  const last2days = moment().subtract(2, 'days');
  const loggedInUser = sessionStorage.getItem("tm_token");
  const foundUser = JSON.parse(loggedInUser);
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [excelUploadCount, setExcelUploadCount] = useState('')
  const [selectedFromDate, setSelectedFromDate] = useState(new Date(new Date().setDate(new Date().getDate() - daysBetweenDates() + 1)));
  const [selectedToDate, setSelectedToDate] = useState(new Date());
  const [rowDetails, setRowDetails] = useState([])
  const [exportTableData, setExportTableData] = useState([]);

    useEffect(() => {
      homeTableData();
    },[])


    const homeTableData = () => {
      setLoading(true);
      const fromDate = new Date(selectedFromDate).toDateString()
      const toDate = new Date(selectedToDate).toDateString()
      axios.get(baseURL + "/get_all_asa_details?from="+fromDate+"&to="+toDate)
      .then((res) => {
        var j = 1;
        if(res.status === 200){
          let rowsData = [];
          let ExportTableData = [];
          const myDataSet = res.data;
          for (var index = 0; index < res.data.length; index++) {
            let rowItem = {};
            const val = myDataSet[index];
            // const est_datetime = moment(new Date(val.uploaded_datetime)).tz("US/Eastern").format('MM/DD/YYYY hh:mm A')
            const from_date = new Date(val.from_date);
            const day = String(from_date.getDate()).padStart(2, '0');
            const month = String(from_date.getMonth() + 1).padStart(2, '0');
            const year = from_date.getFullYear();
            const formatted_from_date = `${month}/${day}/${year}`;

            const to_date = new Date(val.to_date);
            const day1 = String(to_date.getDate()).padStart(2, '0');
            const month1 = String(to_date.getMonth() + 1).padStart(2, '0'); 
            const year1 = to_date.getFullYear();
            const formatted_to_date = `${month1}/${day1}/${year1}`;
            rowItem["id"] = j;
            rowItem['return_date'] = moment(val.return_date).format('MM/DD/YYYY');
            rowItem['agreement_number'] = val.agreement_number
            rowItem['vin'] = val.vin
            rowItem['amount'] = val.amount
            rowItem['total'] = val.total
            rowItem["uploaded_by"] = val.uploaded_by;
            rowItem["uploaded_datetime"] = moment(new Date(val.uploaded_datetime)).tz("US/Eastern").format('MM/DD/YYYY hh:mm A');
            rowsData.push(rowItem)
            ExportTableData.push([j, val.agreement_number,rowItem['return_date'],val.unit,val.vin,val.amount,val.total,val.uploaded_by,rowItem["uploaded_datetime"]])
            j++;
          }
          setExportTableData(ExportTableData)
          setRowDetails(rowsData);
        }else{
          setRowDetails([]);
        }
        setLoading(false);
      })
    }

    const ConvertToTimeZone = (datetime, agr_number) => {
      const location = agr_number.substring(0, 3);
      const timezone = {
          'DEN': 'America/Denver',
          'AURORA':'America/Denver',
          'MCO': 'America/New_York',
          'ATL': 'America/New_York',
          'ORD': 'America/Chicago',
          'YYZ': 'America/Toronto', 
          'YYC': 'America/Edmonton',
          'YVR': 'America/Vancouver',
          'YUL': 'America/Toronto',
          'YOW': 'America/Toronto',
          "PHX": "America/Phoenix",
          "TPA":"America/New_York"
      }
      const convertedTime = moment(datetime).tz(timezone[location]).format('YYYY-MM-DD HH:mm:ss A');
      return convertedTime
  };
  const handleImport = async ($event) => {
    const files = $event.target.files;
    if (files.length) {
      const file = files[0];
      const formData = new FormData();
      formData.append('file', file);
      formData.append('admin_id', foundUser['tm_id']);

      try {
        await axios.post(baseURL + "/save_agent_sale_report", formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
      } catch (error) {
        console.error('Error uploading file:', error);
        Swal.fire({
          icon: 'error',
          text: 'Failed to upload file.'
        });
        return;
      }

      const reader = new FileReader();
      reader.onload = async (event) => {
        const wb = read(event.target.result);
        const sheets = wb.SheetNames;
        if (sheets.length) {
          const rows = utils.sheet_to_json(wb.Sheets[sheets[0]], { header: 1, defval: "" });

          const requiredHeaders = ["R/A Number", "Drop Off Date", "Assigned Unit", "Assigned Unit VIN", "Amount"];
          const headers = rows[0].map(h => h.trim());
          const missingHeaders = requiredHeaders.filter(h => !headers.includes(h));

          if (missingHeaders.length) {
            Swal.fire({
              icon: 'error',
              html: `Your file is missing the following required columns: <b>${missingHeaders.join(', ')}</b>.`
            });
            return;
          }

          const data = utils.sheet_to_json(wb.Sheets[sheets[0]]);
          if (data.length > 4000) {
            Swal.fire({
              icon: 'error',
              text: "Oops! Your file size is " + data.length + ", but the maximum allowed size is 4000. Please reduce your file size and try again."
            });
            return false;
          }

          if (data.length > 0) {
            setLoading(true);
            setExcelUploadCount('Uploading...');

            try {
              await axios.post(baseURL + "/upload_bcf_excel", {
                data: JSON.stringify(data),
                admin_id: foundUser['tm_id']
              });

              await axios.post(baseURL + "/update_bcf_agent_report_count", {
                record_count: data.length,
                admin_id: foundUser['tm_id']
              });

              setExcelUploadCount('');
              Swal.fire({
                icon: 'success',
                text: "Agent Sales Activity report updated successfully."
              }).then(() => {
                homeTableData();
              });

            } catch (error) {
              console.error('Error uploading data:', error);
              Swal.fire({
                icon: 'error',
                text: 'Failed to upload data.'
              });
            } finally {
              setLoading(false);
            }

          } else {
            Swal.fire({
              icon: 'error',
              text: 'You have uploaded an empty file.'
            });
            return;
          }
        }
      };
      reader.readAsArrayBuffer(file);
    }
    fileInputRef.current.value = '';
  };


    const handleDownload =  async (filename) => {
      try {
        const response = await axios.get(baseURL + "/download_asa_file/"+filename, 
        {
          responseType: 'blob' // Important to handle the file download
        });
    
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename; // Set the filename for download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('Error downloading the file:', error);
      }
    }

    const handleSubmit = () => {
      homeTableData()
    }

    const data = {
      columns: [
        {
          label: 'S.No',
          field: 'id',
        },
        {
          label: 'Return Date',
          field: 'return_date'
        },
        {
          label: 'Agreement Number',
          field: 'agreement_number'
        },
        {
          label: 'VIN',
          field: 'vin'
        },
        {
          label: 'Amount',
          field: 'amount'
        },
        {
          label: 'Total',
          field: 'total'
        },
        {
          label: 'Uploaded By',
          field: 'uploaded_by'
        },
        {
          label: 'Uploaded Datetime',
          field: 'uploaded_datetime'
        }
      ],
      rows: rowDetails
    }
    const searchOptions = {
      text: 'Search by name', // Placeholder text for the search input
      showSearch: true, // Show the search input
      searchLabel: 'Search:', // Label for the search input
    };

    const handleDownloadTemplate = () => {
      const headings = [['R/A Number','Drop Off Date','Assigned Unit','Assigned Unit VIN','Amount']];
      const sampleVin = [['ORD-160712','07-01-2024 12:46 AM','7463','1C4PJXEN2RW179533','76.93'],['ORD-160715','07-01-2024 01:40 AM','7392','1C4PJXEN0RW179529','87.92']];
      const wb = utils.book_new();
      const ws = utils.json_to_sheet([]);
      utils.sheet_add_aoa(ws, headings);
      utils.sheet_add_json(ws, sampleVin, { origin: 'A2', skipHeader: true });
      ws['!cols'] = [{ width: 20 }];
      utils.book_append_sheet(wb, ws, 'Agent Sales Activity Sample');
      writeFile(wb, 'Agent Sales Activity Sample.xlsx');
    }

    const handleExportTableData = () => {
      const headings = [['S.No','R/A Number','Date','Unit','VIN',"Amount",'Total','Uploaded By','Uploaded Datetime']];
      const sampleVin = exportTableData;
      const wb = utils.book_new();
      const ws = utils.json_to_sheet([]);
      utils.sheet_add_aoa(ws, headings);
      utils.sheet_add_json(ws, sampleVin, { origin: 'A2', skipHeader: true });
      utils.book_append_sheet(wb, ws, 'Agent Sales Activity');
      writeFile(wb, 'Agent Sales Activity.xlsx');
    }
    
    return (
        <div className='body_class'>
          {loading ? (
            <div className="loader-overlay">
                <div className="loader">
                <div className='excel-upload-count'>{excelUploadCount}</div>
                <PuffLoader color="#00308F" loading={true} size={200} />
                </div>
            </div>
          ) : ("")}
          <div className='container-fluid'>
            <h4>Agent Sale Activity</h4>
            <div className="mt-3">
                {foundUser['tm_accessRole']['Fleet']['Edit'] == true &&
                    <>
                    <div className='row p-4 align-items-center'>
                      <div className="col-auto mt-1">
                        <label htmlFor="datepicker" className="form-label">Start Date:</label>
                      </div>
                      <div className='col-2'>
                        <DatePicker
                          id="datepicker"
                          selected={selectedFromDate}
                          value={selectedFromDate ? moment(new Date(selectedFromDate)) : selectedFromDate}
                          // onChange={(date) => setSelectedFromDate(date)}
                          onChange={(date, dateString) => { setSelectedFromDate(date);}}
                          className="form-control" // Bootstrap class for input fields
                        />
                      </div>
                      <div className="col-auto mt-1">
                        <label htmlFor="datepicker" className="form-label">To Date:</label>
                      </div>
                      <div className='col-2'>
                        <DatePicker
                          id="datepicker"
                          selected={selectedToDate}
                          value={selectedToDate ? moment(new Date(selectedToDate)) : selectedToDate}
                          // onChange={(date) => setSelectedToDate(date)}
                          onChange={(date, dateString) => { setSelectedToDate(date);}}
                          className="form-control" // Bootstrap class for input fields
                        />
                      </div>
                      <div className="col-auto">
                          <Button variant="contained" onClick={handleSubmit} >Submit</Button>
                      </div>
                    </div>
                    <Button size="large" className="mt-4"  type="submit" variant="contained" onClick={handleExportTableData}>
                      <RiFileExcel2Fill size={18}/>&nbsp;Export Excel
                    </Button>
                    <Button size="large" className="mt-4" style={{marginLeft:"2rem"}} type="submit" variant="contained" onClick={handleDownloadTemplate}>
                      <FaDownload size={18}/>&nbsp;Download Template
                    </Button>
                    <input
                      type="file"
                      id="select-csv"
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      style={{ display: 'none' }}
                      multiple={false}
                      required
                      onChange={handleImport}
                      ref={fileInputRef}
                    />
                    <label htmlFor="select-csv" style={{marginBottom: '0'}}>
                      <Button size='large' variant="contained" style={{marginLeft:"2rem"}} className="btn btn-primary mt-4" component="span">
                        <FaUpload size={18}/>&nbsp;Upload Excel
                      </Button>
                    </label>
                    </>
                }
            </div>
            <div className="row mt-1">
              <div className="col-md-12">
                <MDBDataTable
                  bordered
                  data={data}
                  large={true}
                  displayEntries={false}
                  search={searchOptions}
                  noBottomColumns={true}
                  className="pagination-right-aligned"
                  searching={true}
                />
              </div>
            </div>
          </div>
      </div>
    )

}

export default AgentSaleActivity;